export default {
  en: {
    ci_cd: {
      pipeline: {
        start: "Run pipeline"
      }, 
      titles: {
        enabled: 'Enabled',
        disabled: 'Disabled',
        key: 'Key',
        value: 'Value',
        mask: 'Masking',
        existingVariables: 'Existing Variables',
        existingVariablesPipeline: 'Variables from the configuration', 
        newVariables: 'New Variables',
        cancelChanges: 'Cancel Changes',
        save: 'Save',
        environment: 'Environment'
      },
      placeholders: {
        key: 'Key',
        value: 'Value',
        environment: 'Environment'
      }
    },
    webhook: {
      titles: {
        url: 'URL for sending data'
      },
      actions: {
        testUrl: 'Check'
      }
    }
  },
  ru: {
    ci_cd: {
      pipeline: {
        start: "Запуск конвейера"
      }, 
      titles: {
        enabled: 'Включено',
        disabled: 'Отключено',
        key: 'Ключ',
        value: 'Значение',
        mask: 'Маскирование',
        existingVariables: 'Существующие переменные',
        existingVariablesPipeline: 'Переменные из конфигурации', 
        newVariables: 'Создать новую переменную',
        cancelChanges: 'Отменить',
        save: 'Сохранить изменения',
        environment: 'Окружение'
      },
      placeholders: {
        key: 'Ключ',
        value: 'Значение',
        environment: 'Окружение'
      }
    },
    webhook: {
      titles: {
        url: 'URL для отправки данных'
      },
      actions: {
        testUrl: 'Проверить'
      }
    }
  }
};
